import GetBusinessDetailRequestModelBase from '../_generated/modelBases/get-business-detail-request-model-base';

export default class GetBusinessDetailRequestModel extends GetBusinessDetailRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
